<template>
  <div class="row plain-element">
    <div v-if="!isLoggedIn()" class="dashboard-cards">
      <NoPermissionComponent/>
    </div>
    <div v-if="getUsername()" class="dashboard" v-cloak>
      <div class="row row-cards">
        <div class="row text-start row-back">
          <a href="/">
            <span class="material-icons chevron-left">chevron_left</span> Back To Homepage
          </a>
        </div>
        <div  v-if="getMeterHealthCheckDashboards()"  class="card card-description">
            <div class="row plain-element">
                <div class="row-plans-tabs plain-element text-center">
                    <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">

                    </div>
                    <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">

                    </div>
                    <div class=" col col-12 col-sm-12 col-md-2 col-lg-5 plain-element"></div>
                    <div  v-if="activatedTab === 'sites'" class=" col col-12 col-sm-12 col-md-5 col-lg-3 plain-element">
                      <div class="row searchbox-wrapper">
                          <input id="keyWordSearchbox"  v-model="search" type="text" placeholder="Filter Sites e.g. Site, place, boilers"
                          aria-label="e.g. Steam" class="form-control" style="height: 42px;">
                      </div>
                    </div>
                </div>
            </div>
            <div class="row row-break"></div>
            <div v-if="activatedTab === 'sites'" class="row plain-element">
             <div class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
                <div  v-for="(value, key) in keywordFilteredList.slice(0,14)" class="input-field  col col-12 col-sm-12 col-form" :key="key" :value="value">
                    <a @click="goToMeterHealthCheck(value.site_code)">
                      <div class="card menu-card">
                        <div class="row plain-element">
                            <div class=" col col-12 col-sm-2 col-md-3 col-lg-3 plain-element">
                             <img :src="'https://saperapublicstorage.blob.core.windows.net/media/logos/' + value.company_name + '.png'" alt="Logo" style="height: 30px; margin-top: 10px;"/>
                            </div>
                            <div class=" col col-12 col-sm-10 col-md-9 col-lg-9 plain-element">
                                <h5><span class="material-icons chevron-right">chevron_right</span> {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span> </h5>
                            </div>
                        </div>
                      </div>
                    </a>
                </div>
             </div>
             <div class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
                <div  v-for="(value, key) in keywordFilteredList.slice(14,28)" class="input-field  col col-12 col-sm-12 col-form" :key="key" :value="value">
                    <a @click="goToMeterHealthCheck(value.site_code)">
                      <div class="card menu-card">
                        <div class="row plain-element">
                            <div class=" col col-12 col-sm-2 col-md-3 col-lg-3 plain-element">
                             <img :src="'https://saperapublicstorage.blob.core.windows.net/media/logos/' + value.company_name + '.png'" alt="Logo" style="height: 30px; margin-top: 10px;"/>
                            </div>
                            <div class=" col col-12 col-sm-10 col-md-9 col-lg-9 plain-element">
                                <h5><span class="material-icons chevron-right">chevron_right</span> {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span> </h5>
                            </div>
                        </div>
                      </div>
                    </a>
                </div>
             </div>
             <div class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
                <div  v-for="(value, key) in keywordFilteredList.slice(28,42)" class="input-field  col col-12 col-sm-12 col-form" :key="key" :value="value">
                    <a @click="goToMeterHealthCheck(value.site_code)">
                      <div class="card menu-card">
                        <div class="row plain-element">
                            <div class=" col col-12 col-sm-2 col-md-3 col-lg-3 plain-element">
                             <img :src="'https://saperapublicstorage.blob.core.windows.net/media/logos/' + value.company_name + '.png'" alt="Logo" style="height: 30px; margin-top: 10px;"/>
                            </div>
                            <div class=" col col-12 col-sm-10 col-md-9 col-lg-9 plain-element">
                                <h5><span class="material-icons chevron-right">chevron_right</span> {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span> </h5>
                            </div>
                        </div>
                      </div>
                    </a>
                </div>
             </div>
             <div class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
                <div  v-for="(value, key) in keywordFilteredList.slice(42)" class="input-field  col col-12 col-sm-12 col-form" :key="key" :value="value">
                    <a @click="goToMeterHealthCheck(value.site_code)">
                      <div class="card menu-card">
                        <div class="row plain-element">
                            <div class=" col col-12 col-sm-2 col-md-3 col-lg-3 plain-element">
                                <img :src="'https://saperapublicstorage.blob.core.windows.net/media/logos/' + value.company_name + '.png'" alt="Logo" style="height: 30px; margin-top: 10px;"/>
                            </div>
                            <div class=" col col-12 col-sm-10 col-md-9 col-lg-9 plain-element">
                                <h5><span class="material-icons chevron-right">chevron_right</span> {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span> </h5>
                            </div>
                        </div>
                      </div>
                    </a>
                </div>
             </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "MeterHealthCheckSiteSelectView",
  components: {
    NoPermissionComponent,

  },
  props: {

  },
  data() {
    return {
      site: "",
      search: "",
      querySearch: "",
      activatedTab: "sites",
    }
  },

  methods: {
    ...mapGetters(["getUsername", "isLoggedIn", "getServiceSitesAndSeu", "getLoader",
                    "getFormError","getMeterHealthCheckDashboards", "getSiteNames", "getUserEnergyEyeRecentQueries"]),
    ...mapActions(["performSetFormError", "fetchMeterHealthCheckDashboards", "fetchSites"]),

    goToMeterHealthCheck(site_code) {
      location.href=(`/meter-health-check/${site_code}`);
    },
    
    activateTab(activatedTab) {
        this.activatedTab = activatedTab
    },
    transformMeterString(input) {
        // Remove the brackets and single quotes, and then split by comma
        const items = input.replace(/[[\]']/g, '').split(',');

        // Trim any leading or trailing whitespace from each item
        const trimmedItems = items.map(item => item.trim());

        // Join the items with " | "
        return trimmedItems.join(' ---|--- ');
    }
  },
  computed: {
    keywordFilteredList() {
      return this.getMeterHealthCheckDashboards()
      .filter(element => {
        return element.company_name.toLowerCase().includes(this.search.toLowerCase()) ||
               element.site_code.toLowerCase().includes(this.search.toLowerCase()) ||
               element.site_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },

  created() {
    document.title = "Site Select";
    this.performSetFormError(null)
    this.fetchMeterHealthCheckDashboards();
    window.scrollTo(0,0);
  }
}


</script>
<style scoped>
.expanded {
  cursor: pointer;
}
.expanded:hover {
  text-decoration: underline;
}
</style>